import { KeycloakConfig, KeycloakInitOptions, KeycloakService } from 'keycloak-angular';
import { environment } from '../environments/environment';
import { Platform } from '@ionic/angular';
import { MobileService } from './mobile.services';
import { EventEmitter } from '@angular/core';
import JSEncrypt from 'jsencrypt';
import { AppInitService } from './services/app-init.service';
import { ResponsiveService } from './responsive.service';

declare let window: any;

export function initializer(mobileService: MobileService, appInit:AppInitService, responsive:ResponsiveService): () => Promise<any> {
  return (): Promise<any> => {
    const configInitSuccess = async function (resolve, reject) {
      responsive.initialize();
      if (window['cordova']) {
        mobileService.appReady = new EventEmitter();
        mobileService.appReady.subscribe(
          () => {
            resolve(null);
          }
        );
        mobileService.initialize();
      }
      else {
        sessionStorage.setItem('deviceId', window.browserFingerprint);
        resolve(null);
      }
    }

    console.log("-- app init --");
    return new Promise(async (resolve, reject) => {

      appInit.init = new EventEmitter();
      appInit.init.subscribe(
        async (res) => {
          configInitSuccess(resolve, reject);
        }
      );
      appInit.loadConfig();

    });
  };
}